import { NgModule } from '@angular/core';
import { languagesPipe } from './languages';
import { sanitizeHtmlPipe } from './sanitize-html';
import { Translate2Pipe } from './translate2';
import { Translate3Pipe } from './translate3';
import { TranslateCodePipe } from './translate';
import { FormatDatePipe } from "./format-date.pipe";
import { NetworkUserPipe } from './network-user.pipe';
import { NetworkProvider } from '../providers/network';
import { NetworkMessagesPipe } from './network-messages.pipe';
import { AuthData } from '../providers/auth';
import { UserInfoPipe } from './user-info.pipe';
import { UserRequestsPipe } from './user-requests.pipe';
import { RequestProvider } from '../providers/request';
import { FromApiPipe } from './from-api.pipe';
import { SponsorDataPipe } from './sponsor-data.pipe';
import { colorPipe } from './color.pipe';
import { OrderByPipe } from './order-by';
import { FilterArrayPipe } from './filter-array.pipe';
import { CreditCardTypePipe } from './credit-card-type.pipe';
import { ProductDataPipe } from './product-data.pipe';
import { TotalAmountPipe } from './total-amount.pipe';
import { ArrayObjectPipe } from './array-object.pipe';
import { ProfileNetworkingPipe } from './profile-networking.pipe';
import { UserInterestPipe } from './user-interest';
import { CatalogMatchPipe } from './catalog-ai.pipe';
import { EventMatchPipe } from './event-ai.pipe';
import { TranslateConfigPipe } from './translate-config';
import { TranslateClientConfigPipe } from './translate-client-config';
import { TruncatePipe } from './limit.pipe';
import { StaffDataPipe } from './staff-data.pipe';
import { TimeFormat } from './format-hour.pipe';
import { isFavoritePipe } from './favorites.pipe';
import { favoriteDataPipe } from './favorite-data.pipe';
import { CommercialMatchPipe } from './commercial-ai.pipe';
import { ClientCurrencyPipe } from './client-currency.pipe';
import { TranslateCustomPipe } from './custom-translate';
import { PointsUserPipe } from './user-points.pipe';
import { CouponMatchPipe } from './coupons-ai.pipe';
import { UserHistoryPointsPipe } from './userHistoryPoints.pipe';
import { NumberSmallPipe } from './number-small.pipe';
import { ReserveDataPipe } from './reserveData.pipe';
import { EntityReserveDataPipe } from './entityReserveData.pipe';
import { CatalogRankPipe } from './catalog-rank.pipe';
import { calendarReserveDataPipe } from './calendarsReserve';
import { toCategorynamePipe } from './toCategoryName.pipe';
import { StaffConfigDataipe } from './staff-data-config.pipe';
import { ServiceReservePipe } from './service-reserve.pipe';
import { StaffConfigModuleDataPipe } from './staff-config-module';
import { EventInfoDataPipe } from './event-info.pipe';
import { ComercialSampleInfoDataPipe } from './comercialSampleInfo';
import { CategorieStaffDataPipe } from './categories-staff.pipe';
import { ServiceDataPipe } from './service-data.pipe';

export const PIPES = [
  Translate2Pipe,
  Translate3Pipe,
  languagesPipe,
  sanitizeHtmlPipe,
  FormatDatePipe,
  TimeFormat,
  NetworkUserPipe,
  NetworkMessagesPipe,
  UserInfoPipe,
  PointsUserPipe,
  UserRequestsPipe,
  UserHistoryPointsPipe,
  FromApiPipe,
  SponsorDataPipe,
  colorPipe,
  OrderByPipe,
  FilterArrayPipe,
  CreditCardTypePipe,
  isFavoritePipe,
  favoriteDataPipe,
  ProductDataPipe,
  CatalogMatchPipe,
  TotalAmountPipe,
  ArrayObjectPipe,
  ProfileNetworkingPipe,
  UserInterestPipe,
  EventMatchPipe,
  TranslateCodePipe,
  TranslateConfigPipe,
  calendarReserveDataPipe,
  ReserveDataPipe,
  TranslateClientConfigPipe,
  StaffDataPipe,
  CategorieStaffDataPipe,
  TruncatePipe,
  CommercialMatchPipe,
  ClientCurrencyPipe,
  TranslateCustomPipe,
  CouponMatchPipe,
  NumberSmallPipe,
  EntityReserveDataPipe,
  CatalogRankPipe,
  toCategorynamePipe,
  StaffConfigDataipe,
  ServiceReservePipe,
  StaffConfigModuleDataPipe,
  ComercialSampleInfoDataPipe,
  EventInfoDataPipe,
  ServiceDataPipe
];

@NgModule({
  imports: [],
  exports: [...PIPES],
  declarations: [...PIPES],
  providers: [NetworkProvider, AuthData, RequestProvider, ...PIPES],
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts